import { BUILD_EVENT, EEVents } from '@core/constants';
import * as Events from '@core/events';
import { handler as validationHandler } from '@core/handlers/field/validations';
import Field from '@core/managers/Field';
import { TEventReducedSchema, TFields, TSubmitValueData } from '@core/types';
import { getScopedField } from '@core/utils/common';

export const handler = ({
  form,
  payload,
}: Pick<Events.TEventInformation<TSubmitValueData>, 'form' | 'payload'>) => {
  const fields = getScopedField<TFields>(form.fields, Object.keys(payload));
  Object.keys(fields).forEach((key) => {
    const value = payload?.[key]?.value;
    const field: Field = fields[key];
    field.value = value ? value : '';
    field.componentProps = { ...field.componentProps, ...payload[key].props };
    const validationsEvents = Object.keys(field.scopedComponent.validations);
    const validations = validationsEvents.reduce((acc, curr: EEVents) => {
      return { ...acc, ...field.eventReducedSchema(curr).validations };
    }, {});
    /**
    * Test if its necessary to maintain those two lines of handlers above.
    */
    validationHandler({
      field,
      eventReducedSchema: {
        validations,
      } as TEventReducedSchema,
      form,
    });
    field.publish(BUILD_EVENT(EEVents.ON_FIELD_BINDED, field.component.name));
    field.rehydrate();
  });
};
